export default "__VITE_ASSET__6c3739b7__"